export const VIEWPORT_MARGIN = 8;

/**
 * Position a fixed menu relative to a trigger, flipping/clamping to stay in the viewport.
 */
export function computeFloatingMenuPosition({
  triggerRect,
  menuHeight = 220,
  menuWidth = 160,
  align = "end",
}) {
  if (!triggerRect) return null;

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const spaceBelow = viewportHeight - triggerRect.bottom;
  const opensUpward = spaceBelow < menuHeight + VIEWPORT_MARGIN;

  const unclampedTop = opensUpward
    ? triggerRect.top - menuHeight - 4
    : triggerRect.bottom + 4;
  const unclampedLeft =
    align === "start" ? triggerRect.left : triggerRect.right - menuWidth;

  const top = Math.max(
    VIEWPORT_MARGIN,
    Math.min(unclampedTop, viewportHeight - menuHeight - VIEWPORT_MARGIN)
  );
  const left = Math.max(
    VIEWPORT_MARGIN,
    Math.min(unclampedLeft, viewportWidth - menuWidth - VIEWPORT_MARGIN)
  );

  return { top, left };
}
